// extracted by mini-css-extract-plugin
export default {"safeHeader":"index_safeHeader_1JwaU"};